import { Dialog, DialogTitle, DialogActions, DialogContent, Typography, Button } from "@mui/material";
import { dialogTypes, ProofDialogType, ProofTitlesType, proofTitles } from "../actions/data";
import { DialogContentContainer, DialogContentItem } from "./styles";
import { formatDateMMDDYYYY } from "../../../../util/DateUtils";

const ProofDialog = (props: ProofDialogType) => {

  const {open, onClose, account, type} = props;

  const title = proofTitles[type as keyof ProofTitlesType];

  let version: number | null = 0;
  let email: string | null = '';
  let ipAddress: string | null = '';
  let agreedToDate: string | null = '';

  if(account) {
    if(type === dialogTypes.PROOF_PP) {
      version = account.policyVersion;
      email = account.privacyPolicyAgreedToEmail;
      ipAddress = account.privacyPolicyAgreedToIp;
      agreedToDate = account.privacyPolicyAgreeToDate;
    } else {
      version = account.termsVersion;
      email = account.termsAgreedToEmail;
      ipAddress = account.termsAgreedToIp;
      agreedToDate = account.termsAgreedToDate;
    }
  }
  
  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title} Details</DialogTitle>
    <DialogContent>
      <DialogContentContainer>
        <DialogContentItem>
          <Typography>Version: {version ? version : ''}</Typography>
        </DialogContentItem>
        <DialogContentItem>
          <Typography>Signed on: {agreedToDate && formatDateMMDDYYYY(agreedToDate)}</Typography>
        </DialogContentItem>
        <DialogContentItem>
          <Typography>Signed by email: {email ? email : ''}</Typography>
        </DialogContentItem>
        <DialogContentItem>
          <Typography>IP address: {ipAddress ? ipAddress : ''}</Typography>
        </DialogContentItem>
      </DialogContentContainer>
    </DialogContent>
    <DialogActions>
      <Button variant='outlined' onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>;
}

export default ProofDialog;